import React, { useState, useEffect } from "react";
import axios from "axios";

export default function AddService() {
  const [category, setCategory] = useState("");
  const [services, setServices] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [newService, setNewService] = useState({
    name: "",
    price: "",
    lockQuantity: false,
    placeholder: "",
    description: "",
  });

  // ✏️ Edit state
  const [editService, setEditService] = useState(null);

  // ✅ Fetch all services
  const fetchServices = async () => {
    try {
      const res = await axios.get("https://api.speedfollowinfo.com/api/services");
      if (res.data.success) setServices(res.data.services);
    } catch (err) {
      console.error("❌ Fetch Services Error:", err);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  // ✅ Submit multiple services under one category
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!category || serviceList.length === 0)
      return alert("⚠️ Category & at least one service required!");

    try {
      const res = await axios.post("https://api.speedfollowinfo.com/api/services/bulk", {
        category,
        services: serviceList,
      });

      if (res.data.success) {
        alert("✅ Services added successfully!");
        setCategory("");
        setServiceList([]);
        fetchServices();
      }
    } catch (err) {
      console.error("❌ Add Service Error:", err);
      alert("❌ Failed to add services!");
    }
  };

  // ✅ Add a new service input row
  const handleAddToList = () => {
    if (!newService.name || !newService.price)
      return alert("⚠️ Service name and price required!");
    setServiceList((prev) => [...prev, newService]);
    setNewService({
      name: "",
      price: "",
      lockQuantity: false,
      placeholder: "",
      description: "",
    });
  };

  // ✅ Toggle Single Service (On/Off)
  const handleToggle = async (id) => {
    try {
      const res = await axios.put(`https://api.speedfollowinfo.com/api/services/${id}/toggle`);
      if (res.data.success) {
        setServices(res.data.services); // 👈 backend থেকে full updated list আসে

        const msg = document.createElement("div");
        msg.textContent = res.data.message;
        msg.style.position = "fixed";
        msg.style.top = "20px";
        msg.style.right = "20px";
        msg.style.background = res.data.isActive ? "#4ade80" : "#f87171";
        msg.style.color = "#0b0f1a";
        msg.style.padding = "10px 18px";
        msg.style.borderRadius = "8px";
        msg.style.fontWeight = "600";
        msg.style.zIndex = "9999";
        document.body.appendChild(msg);
        setTimeout(() => msg.remove(), 1500);
      }
    } catch (err) {
      console.error("❌ Toggle Error:", err);
    }
  };

  // ✅ Toggle ALL Services (On/Off)
  const handleToggleAll = async (status) => {
    try {
      const res = await axios.put("https://api.speedfollowinfo.com/api/services/toggle-all", { status });

      if (res.data.success) {
        setServices(res.data.services);

        const msg = document.createElement("div");
        msg.textContent = res.data.message;
        msg.style.position = "fixed";
        msg.style.top = "20px";
        msg.style.right = "20px";
        msg.style.background = status ? "#4ade80" : "#f87171";
        msg.style.color = "#0b0f1a";
        msg.style.padding = "10px 18px";
        msg.style.borderRadius = "8px";
        msg.style.fontWeight = "600";
        msg.style.zIndex = "9999";
        document.body.appendChild(msg);
        setTimeout(() => msg.remove(), 1500);
      }
    } catch (err) {
      console.error("❌ Toggle All Error:", err);
      alert("❌ Failed to toggle all services!");
    }
  };

  // ✅ Delete Service
  const handleDelete = async (id) => {
    if (!window.confirm("🗑 Are you sure to delete this service?")) return;
    try {
      const res = await axios.delete(`https://api.speedfollowinfo.com/api/services/${id}`);
      if (res.data.success) {
        if (Array.isArray(res.data.services)) {
          setServices(res.data.services);
        } else {
          setServices((prev) => prev.filter((s) => s._id !== id));
        }

        const msg = document.createElement("div");
        msg.textContent = "🗑 Service deleted!";
        msg.style.position = "fixed";
        msg.style.top = "20px";
        msg.style.right = "20px";
        msg.style.background = "#f87171";
        msg.style.color = "#fff";
        msg.style.padding = "10px 18px";
        msg.style.borderRadius = "8px";
        msg.style.fontWeight = "600";
        msg.style.zIndex = "9999";
        document.body.appendChild(msg);
        setTimeout(() => msg.remove(), 1500);
      }
    } catch (err) {
      console.error("❌ Delete Error:", err);
    }
  };

  // ✅ Update Service (Edit)
  const handleUpdate = async () => {
    try {
      const res = await axios.put(
        `https://api.speedfollowinfo.com/api/services/${editService._id}`,
        editService
      );
      if (res.data.success) {
        setServices((prev) =>
          prev.map((s) => (s._id === editService._id ? res.data.service : s))
        );
        setEditService(null);
        alert("✅ Service updated successfully!");
      }
    } catch (err) {
      console.error("❌ Update Error:", err);
      alert("❌ Failed to update service!");
    }
  };

  // ✅ Group services by category
  const grouped = services.reduce((acc, s) => {
    if (!acc[s.category]) acc[s.category] = [];
    acc[s.category].push(s);
    return acc;
  }, {});

  return (
    <div className="p-6 bg-[#0b0f1a] text-white min-h-screen">
      <h2 className="text-2xl font-bold mb-6 text-[#f2a900]">
        ➕ Add New Services
      </h2>

      {/* 🔹 Add Service Form */}
      <form
        onSubmit={handleSubmit}
        className="bg-[#151c34] p-6 rounded-xl border border-[#1e2550] shadow-lg mb-8"
      >
        <label className="block mb-1 font-semibold">🗂️ Category Name</label>
        <input
          type="text"
          placeholder="e.g. Facebook Lock, YouTube Premium"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className="w-full p-3 mb-5 rounded-md bg-[#0f1530] border border-[#30365f] text-white"
          required
        />

        {/* 🔸 Add multiple services inputs */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <input
            type="text"
            placeholder="🧩 Service Name"
            value={newService.name}
            onChange={(e) =>
              setNewService({ ...newService, name: e.target.value })
            }
            className="p-3 rounded bg-[#0f1530] border border-[#30365f]"
          />
          <input
  type="number"
  placeholder="$ Price"
  value={newService.price}
  onChange={(e) =>
    setNewService({ ...newService, price: e.target.value })
  }
  className="p-3 rounded bg-[#0f1530] border border-[#30365f]"
/>
          <select
            value={newService.lockQuantity}
            onChange={(e) =>
              setNewService({
                ...newService,
                lockQuantity: e.target.value === "true",
              })
            }
            className="p-3 rounded bg-[#0f1530] border border-[#30365f]"
          >
            <option value="false">❌ User can set quantity</option>
            <option value="true">✅ Fixed (1)</option>
          </select>
          <textarea
  placeholder={`এখানে নাম লিখুন :
এখানে নাম্বার লিখুন :`}
  value={newService.placeholder}
  onChange={(e) =>
    setNewService({
      ...newService,
      placeholder: e.target.value,
    })
  }
  rows={3}
  className="p-3 rounded bg-[#0f1530] border border-[#30365f] resize-none"
/>
        </div>

        <textarea
          placeholder="📝 Description (optional)"
          value={newService.description}
          onChange={(e) =>
            setNewService({ ...newService, description: e.target.value })
          }
          className="w-full p-3 mb-3 rounded bg-[#0f1530] border border-[#30365f]"
        />

        <div className="flex gap-3 mb-4">
          <button
            type="button"
            onClick={handleAddToList}
            className="bg-[#3b82f6] hover:bg-[#2563eb] px-4 py-2 rounded font-semibold"
          >
            ➕ Add To List
          </button>
          <button
            type="submit"
            className="bg-[#f2a900] text-black font-bold px-5 py-2 rounded-lg hover:bg-[#e0a800]"
          >
            🚀 Submit All
          </button>
        </div>

        {serviceList.length > 0 && (
          <div className="bg-[#1a2238] rounded p-4 border border-[#30365f]">
            <h4 className="text-[#f2a900] font-bold mb-2">🧩 Added Services:</h4>
            <ul className="space-y-1 text-sm">
              {serviceList.map((s, i) => (
                <li key={i} className="flex justify-between">
                  <span>{s.name}</span>
                  <span>৳{s.price}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </form>

      {/* ✅ Turn All Buttons */}
      <div className="flex gap-3 mb-6">
        <button
          onClick={() => handleToggleAll(true)}
          className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded font-semibold"
        >
          🟢 Turn ON All
        </button>
        <button
          onClick={() => handleToggleAll(false)}
          className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded font-semibold"
        >
          🔴 Turn OFF All
        </button>
      </div>

      {/* 🗂️ Grouped Services */}
      {Object.keys(grouped).length === 0 ? (
        <p className="text-gray-400 italic">No services found.</p>
      ) : (
        Object.entries(grouped).map(([cat, list]) => (
          <div key={cat} className="mb-8 border border-gray-700 rounded-lg overflow-hidden">
            <h3 className="bg-[#111827] text-[#f2a900] text-lg font-bold px-4 py-3">
              🗂️ {cat}
            </h3>
            <table className="w-full text-sm">
              <thead className="bg-[#1a2238] text-[#f2a900]">
  <tr>
    <th className="p-3 text-left flex items-center justify-between">
      <span>Service Name</span>

      {/* Add Service Button (Per Category) */}
      <button
        onClick={() => setCategory(cat)}
        className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-xs font-semibold"
      >
        ➕ Add Service
      </button>
    </th>

    <th className="p-3">Price</th>
    <th className="p-3">Status</th>
    <th className="p-3 text-center">Action</th>
  </tr>
</thead>
              <tbody>
                {list.map((s) => (
                  <tr key={s._id} className="border-b border-gray-700 hover:bg-[#1f2937]">
                    <td className="p-3 text-[#00eaff] font-semibold">{s.name}</td>
                    <td className="p-3">৳{s.price}</td>
                    <td className="p-3">{s.isActive ? "🟢 On" : "🔴 Off"}</td>
                    <td className="p-3 flex gap-2 justify-center">
                      <button
                        onClick={() => handleToggle(s._id)}
                        className={`px-3 py-1 rounded-lg text-xs font-semibold ${
                          s.isActive
                            ? "bg-green-500 hover:bg-green-600"
                            : "bg-gray-500 hover:bg-gray-600"
                        }`}
                      >
                        {s.isActive ? "On" : "Off"}
                      </button>
                      <button
                        onClick={() => setEditService(s)}
                        className="bg-yellow-500 hover:bg-yellow-600 px-3 py-1 rounded-lg text-xs font-semibold"
                      >
                        ✏️ Edit
                      </button>
                      <button
                        onClick={() => handleDelete(s._id)}
                        className="bg-red-500 hover:bg-red-600 px-3 py-1 rounded-lg text-xs"
                      >
                        🗑 Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))
      )}

      {/* ✏️ Edit Modal */}
      {editService && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[9999]">
          <div className="bg-[#151c34] p-6 rounded-xl w-full max-w-md border border-[#30365f]">
            <h2 className="text-xl font-bold mb-4 text-[#f2a900] text-center">
              ✏️ Edit Service
            </h2>

            <input
              type="text"
              value={editService.name}
              onChange={(e) => setEditService({ ...editService, name: e.target.value })}
              className="w-full mb-3 p-2 rounded bg-[#0f1530] border border-[#30365f]"
              placeholder="Service Name"
            />
            <input
              type="number"
              value={editService.price}
              onChange={(e) => setEditService({ ...editService, price: e.target.value })}
              className="w-full mb-3 p-2 rounded bg-[#0f1530] border border-[#30365f]"
              placeholder="Price"
            />
            <input
              type="text"
              value={editService.placeholder}
              onChange={(e) => setEditService({ ...editService, placeholder: e.target.value })}
              className="w-full mb-3 p-2 rounded bg-[#0f1530] border border-[#30365f]"
              placeholder="Placeholder"
            />
            <textarea
              value={editService.description}
              onChange={(e) => setEditService({ ...editService, description: e.target.value })}
              className="w-full mb-3 p-2 rounded bg-[#0f1530] border border-[#30365f]"
              placeholder="Description"
            />

            <div className="flex justify-end gap-2">
              <button
                onClick={handleUpdate}
                className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded font-semibold"
              >
                💾 Update
              </button>
              <button
                onClick={() => setEditService(null)}
                className="bg-gray-600 hover:bg-gray-700 px-4 py-2 rounded font-semibold"
              >
                ❌ Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}